export default __webpack_public_path__ + "static/media/nifty50-whythisshift-points.a577f7dc.png";